import { useId } from "react";

type Props = {
  /** Rendered size in pixels. Width and height stay equal (1:1 viewBox). */
  size?: number;
  className?: string;
  title?: string;
};

/**
 * Noium brand mark — the standalone "n" icon with the brand gradient underline.
 * Vector copy of design-references/assets/thumbnail_white_transparent.svg,
 * centered in a 1000×1000 viewBox so it renders square as a favicon and tab icon.
 */
export function NoiumIcon({ size = 32, className, title = "noium" }: Props) {
  const gradId = useId();
  return (
    <svg
      role="img"
      aria-label={title}
      viewBox="0 0 1000 1000"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id={gradId} x1="53.235611%" y1="100%" x2="46.764389%" y2="0%">
          <stop stopColor="#1E58FF" offset="0%" />
          <stop stopColor="#00FCCB" offset="100%" />
        </linearGradient>
      </defs>
      <g transform="translate(275, 141)" fillRule="nonzero">
        <path
          fill={`url(#${gradId})`}
          transform="translate(225, 660.5263) rotate(90) translate(-225, -660.5263)"
          d="M264.836842,885.526316 L185.163158,885.526316 C175.553403,885.526316 167.763158,877.73607 167.763158,868.126316 L167.763158,452.926316 C167.763158,443.316561 175.553403,435.526316 185.163158,435.526316 L264.836842,435.526316 C274.446597,435.526316 282.236842,443.316561 282.236842,452.926316 L282.236842,868.126316 C282.236842,877.73607 274.446597,885.526316 264.836842,885.526316 Z"
        />
        <path
          fill="currentColor"
          transform="translate(224.3193, 244.1474) rotate(180) translate(-224.3193, -244.1474)"
          d="M223.861935,374.207274 C259.233067,374.207274 284.236799,364.928151 298.873129,346.369904 C313.50946,327.811657 320.217778,301.191221 318.998084,266.508595 L318.998084,17.4 C318.998084,7.79024535 326.788329,-2.48689958e-14 336.398084,-2.48689958e-14 L430.580747,-3.55271368e-15 C440.190501,-3.55271368e-15 447.980747,7.79024535 447.980747,17.4 L447.980747,270.159398 L447.980747,270.159398 C447.980747,303.625089 444.779049,332.223043 438.375655,355.953261 C431.97226,379.683478 421.147474,401.284061 405.901296,420.755008 C394.314201,435.358219 381.659874,446.61486 367.938314,454.524933 C354.216754,462.435005 339.580424,468.976027 324.029322,474.147997 C308.478221,479.319968 292.012349,482.97077 274.631707,485.100405 C257.251064,487.23004 240.327807,488.294858 223.861935,488.294858 C186.051415,488.294858 151.595053,483.122887 120.492851,472.778946 C89.3906486,462.435005 63.4721466,445.093693 42.737345,420.755008 C26.8813203,401.284061 15.9040724,379.683478 9.80560132,355.953261 C3.70713026,332.223043 0.657894737,303.625089 0.657894737,270.159398 L0.657894737,17.4 C0.657894737,7.79024535 8.44814009,-2.13162821e-14 18.0578947,-2.13162821e-14 L112.240558,0 C121.850312,-1.0658141e-14 129.640558,7.79024535 129.640558,17.4 L129.640558,266.508595 L129.640558,266.508595 C129.03071,301.191221 136.348876,327.65954 151.595053,345.913553 C166.841231,364.167567 190.930192,373.598807 223.861935,374.207274 Z"
        />
      </g>
    </svg>
  );
}
